<template>
    <div v-if="ipqualityUrl" id="ipquality">
        <iframe :src="ipqualityUrl" frameborder="0"></iframe>
    </div>
</template>

<script>
export default {
    name: "Ipquality",
    data() {
        return {
            ipqualityUrl: ""
        }
    },
    mounted() {
        this.ipqualityUrl = ""

        if (this.$auth.loggedIn && this.$auth.ipqualityStatus) {
            this.link()
        }
        this.$auth.ipqualityStatus = false
    },
    methods: {
        link() {
            try {
                let deviceID = sessionStorage.getItem("deviceId")
                console.log("deviceID is available", deviceID)
                // If deviceID does NOT exist, call ipquality.html
                if (this.$auth?.loggedIn && deviceID === null) {
                    const userId = this.$auth?.user?._id
                    if (userId) {
                        this.ipqualityUrl = `${window.location.origin}/ipquality.html?userId=${userId}`
                    }
                    setTimeout(() => {
                        deviceID = sessionStorage.getItem("deviceId")
                        console.log("deviceID from API", deviceID)
                        const getOneUser =
                            JSON.parse(
                                sessionStorage.getItem("realDeviceId")
                            ) || []
                        if (
                            deviceID &&
                            deviceID !== "undefined" &&
                            !getOneUser?.includes(deviceID)
                        ) {
                            this.$store.dispatch("userBalance/saveUser", {
                                deviceID
                            })
                            const userAdminUrl =
                                localStorage.getItem("userAdminUrl")
                            fetch(userAdminUrl + "/v2/saveRealDeviceId", {
                                method: "POST",
                                body: JSON.stringify({
                                    deviceId: deviceID
                                }), // string or object
                                headers: {
                                    "Content-Type": "application/json",
                                    accessToken:
                                        localStorage.getItem("accessToken")
                                }
                            })
                        }
                    }, 20000)
                }
            } catch (error) {
                console.log("IPQUALITY ERROR", error)
            }
        }
    }
}
</script>
